import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    SettingType, Setting, BlockType, ValidationMessage, ValidationMessageType,
    CodeBlock,
    SettingOption,
} from '@appblocks/codegeneration/types';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import * as zephyr from './zephyr';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class SPI extends BasePeripheral {
    constructor() {
        super();
        this.id = 'spi';
        this.name = 'SPI Bus';
        this.requirements = ['board', 'spi'];
        // this.fileLinks = [
        //     'ssi\\ssi.tbs',
        //     'ssi\\ssi.tbh',
        // ];
        // this.files = [
        //     'libraries/super_spi/super_spi.tbh',
        //     'libraries/super_spi/super_spi.tbs',
        //     'libraries/ssi/ssi.tbh',
        //     'libraries/ssi/ssi.tbs',
        // ];

        const settings: Array<Setting> = [
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'PORT',
                name: 'Port',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
            },
            {
                id: 'CLK',
                name: 'Clock',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            {
                id: 'DI',
                name: 'DI(MOSI)',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            {
                id: 'DO',
                name: 'DO(MISO)',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            {
                id: 'CLOCKMODE',
                name: 'Clock Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Mode 0: CPOL=0, CPHA=0',
                        value: '0',
                    },
                    {
                        name: 'Mode 1: CPOL=0, CPHA=1',
                        value: '1',
                    },
                    {
                        name: 'Mode 2: CPOL=1, CPHA=0',
                        value: '2',
                    },
                    {
                        name: 'Mode 3: CPOL=1, CPHA=1',
                        value: '3',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'PORT') {
            const options = [];
            const device = PlatformUtils.getDeviceDefinition(this.project.device.id);
            for (let i = 0; i < device.peripherals.length; i++) {
                if (device.peripherals[i].type === 'spi') {
                    options.push({
                        name: device.peripherals[i].id,
                        value: device.peripherals[i].settings.PORT.value,
                    });
                }
            }
            return options;
        }
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            default:
                return zephyr.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/object_ssi';
    }
}
